export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '3.1.2',
};
//# sourceMappingURL=buildEnv.js.map